import { render, staticRenderFns } from "./FloatingToolbar.vue?vue&type=template&id=23fae5c0&scoped=true"
import script from "./FloatingToolbar.vue?vue&type=script&lang=js"
export * from "./FloatingToolbar.vue?vue&type=script&lang=js"
import style0 from "./FloatingToolbar.vue?vue&type=style&index=0&id=23fae5c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fae5c0",
  null
  
)

export default component.exports